<template>
  <div class="my-navbar">
    <mt-navbar v-model="selected">
      <mt-tab-item v-for="(item, index) in tabList" :key="index" :id="index"
        >{{ item.title }}
      </mt-tab-item>
    </mt-navbar>
    <mt-tab-container v-model="selected">
      <img v-lazy="youpPath + tabList[selected].imgUrl" class="poster_img" />
    </mt-tab-container>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
export default {
  data () {
    return {
      youpPath: IMG_BASE_URL,
      selected: 0,
      tabList: [
        {
          SearchType: 4,
          title: '商品口令',
          imgUrl: '/upaiyun/Sys/20220104/5566613451636022186.jpg'
        },
        {
          SearchType: 5,
          title: '视频口令',
          imgUrl: '/upaiyun/Sys/Other/4801674979379395598.jpg'
        },
        {
          SearchType: 6,
          title: '直播间口令',
          imgUrl: '/upaiyun/Sys/Other/5573776187309725481.jpg'
        }
      ]
    }
  },
  created () {
    // 分享口令 = 4, 视频口令 = 5, 直播口令 = 6
    let SearchType = this.$route.query.SearchType
    this.tabList.find((item, index) => {
      if (item.SearchType === SearchType) {
        this.selected = index
      }
    })
  }
}
</script>

<style scoped>
.my-navbar {
  font-size: 12px;
}
.my-navbar .mint-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.my-navbar .mint-tab-item.is-selected {
  border-bottom: 3px solid #dd4c4f;
  color: #dd4c4f;
}

.my-navbar .mint-tab-container {
  padding-top: 51px;
  background: #fff;
}
.poster_img {
  width: 100%;
  display: block;
}
image[lazy="loading"] {
  width: 100%;
  margin: auto;
  background: #fff;
}
</style>
